import axios from 'axios';
import { BASE_PATH_API } from 'constants/env';
import { decodeStorage } from 'functions/storageBase64';

export { getGiftTableLink } from './links';
export { isLogged } from './sessions';
export { getBasePath } from './navigation';
export { downloadFileFromUrl } from './files';

export function getAddressURL({
  street,
  exteriorNumber,
  colony,
  postalCode,
  city,
  state,
  calle,
  numeroExterior,
  colonia,
  codigoPostal,
  ciudad,
  estado,
}) {
  const country = 'México';
  const address = `
    ${street || calle} ${exteriorNumber || numeroExterior} ${
    colony || colonia
  } ${postalCode || codigoPostal} ${city || ciudad} ${
    state || estado
  } ${country}
  `;
  const encodedAddress = encodeURIComponent(address);
  return encodedAddress;
}


export async function getAddressById(addressId, agentToken = null) {
  const token = agentToken || decodeStorage('access_token');
  const accessToken = `Bearer ${token}`;
  const apiURL = `${BASE_PATH_API}/app/v1/address/${addressId}`;
  const config = {
    method: 'get',
    url: apiURL,
    withCredentials: false,
    headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': accessToken
    }
  };

  const res = await axios(config);
  return res.data.data;
};
